import {t} from "../i18n";


export default [
    {
        route_name: "DashboardOverview",
        title: t("dashboard"),
        allowedPermission: 0,
        icon: "bx bx-tachometer",
        children: [],
    },
    {
        route_name: "analytics",
        title: t("analytics"),
        allowedPermission: 0,
        icon: "bx bxs-dashboard",
        children: [
            {
                route_name: "dailyUsageForMonth",
                title: t("dailyUsageForMonth"),
                icon: "bx bx-calendar",
            },
            {
                route_name: "hourlyAppUsage",
                title: t("hourlyAppUsage"),
                icon: "bx bx-time-five",
            },
            {
                route_name: "usersNoLogins",
                title: t("usersNoLogins"),
                icon: "bx bx-user-x",
            },
            {
                route_name: "usersNeverLogins",
                title: t("usersNeverLogins"),
                icon: "bx bx-user-minus",
            },
            {
                route_name: "lessonDownloads",
                title: t("lessonDownloads"),
                icon: "bx bx-download",
            },
        ],
    },
    {
        title: t("users"),
        route_name: "users",
        icon: "bx bx-user",
        allowedPermission: 0,
        children: [
            {
                title: t("AllUsers"),
                route_name: "all-users",
                icon: "bx bx-group",
            },
            {
                title: t("StudentUsers"),
                route_name: "StudentUsers",
                icon: "bx bx-id-card",
            },
            {
                title: t("teacherUsers"),
                route_name: "TeacherUsers",
                icon: "bx bx-chalkboard",
            },
            {
                title: t("ParentUsers"),
                route_name: "ParentUsers",
                icon: "bx bx-user-circle",
            },
        ],
    },
    {
        title: t("academic"),
        route_name: "academic",
        icon: "bx bxs-graduation",
        allowedPermission: 0,
        children: [
            {
                title: t("courses"),
                route_name: "Courses",
                icon: "bx bx-book-open",
            },
            {
                title: t("schools"),
                route_name: "ListOfSchools",
                icon: "bx bxs-school",
            },
            {
                title: t("grades"),
                route_name: "ListOfGrades",
                icon: "bx bx-layer",
            },
            {
                title: t("subjects"),
                route_name: "ListOfSubjects",
                icon: "bx bx-book-content",
            },
            {
                title: t("books"),
                route_name: "BooksList",
                icon: "bx bx-book",
            },
        ],
    },
    {
        title: t("sales-marketing"),
        route_name: "sales-marketing",
        icon: "bx bx-cart-alt",
        allowedPermission: 0,
        children: [
            {
                title: t("packages"),
                route_name: "packagesManagement",
                icon: "bx bx-package",
            },
            {
                title: t("promotions-management"),
                route_name: "promotionsManagement",
                icon: "bx bx-gift",
            },
            {
                title: t("vouchers"),
                route_name: "VoucherManagement",
                icon: "bx bx-purchase-tag",
            },
            {
                title: t("unique-vouchers"),
                route_name: "UniqueVouchers",
                icon: "bx bx-purchase-tag-alt",
            },
            {
                title: t("batches-management"),
                route_name: "VoucherBatchManagement",
                icon: "bx bx-collection",
            },
            {
                title: t("distributors"),
                route_name: "DistributorManagement",
                icon: "bx bx-store-alt",
            },
            {
                title: t("referral-codes"),
                route_name: "ReferralCodesList",
                icon: "bx bx-link",
            },
        ],
    },
    {
        title: t("reports"),
        route_name: "reports",
        icon: "bx bx-bar-chart-alt-2",
        allowedPermission: 0,
        children: [
            {
                title: t("user-info-summary-report"),
                route_name: "userInfoSummaryReport",
                icon: "bx bx-list-ul",
            },
            {
                title: t("wallet-summary-report"),
                route_name: "walletSummaryReport",
                icon: "bx bx-wallet",
            },
            {
                title: t("wallet-transactions-report"),
                route_name: "walletTransactionsReport",
                icon: "bx bx-receipt",
            },
            {
                title: t("package-reports"),
                route_name: "packageReports",
                icon: "bx bx-line-chart",
            },
            {
                title: t("enrollment-report"),
                route_name: "packageEnrollmentReport",
                icon: "bx bx-spreadsheet",
            },
        ],
    },
    {
        title: t("content-support"),
        route_name: "content-support",
        icon: "bx bx-support",
        allowedPermission: 0,
        children: [
            {
                title: t("app-questions"),
                route_name: "Questions",
                icon: "bx bx-question-mark",
            },
            {
                title: t("question-answers"),
                route_name: "QuestionAnswers",
                icon: "bx bx-list-check",
            },
            {
                title: t("testimonials"),
                route_name: "testimonials",
                icon: "bx bx-comment-detail",
            },
            {
                title: t("FAQ"),
                route_name: "FAQ",
                icon: "bx bx-help-circle",
            },
            {
                title: t("faqCategory"),
                route_name: "FaqCategory",
                icon: "bx bx-category",
            },
            {
                title: t("BUGReportList"),
                route_name: "BUGReportList",
                icon: "bx bx-bug",
            },
        ],
    },
    {
        title: t("settings"),
        route_name: "settings",
        icon: "bx bx-cog",
        allowedPermission: 0,
        children: [
            {
                title: t("systemSettings"),
                route_name: "SystemSettings",
                icon: "bx bx-cog",
            },
            {
                title: t("AdminsManagement"),
                route_name: "admins-management-list",
                icon: "bx bx-user",
            },
            {
                title: t("general-subscription"),
                route_name: "generalSubscription",
                icon: "bx bx-package",
            },
            {
                title: t("image-management"),
                route_name: "image-management",
                icon: "bx bx-image",
            },
            {
                title: t("policies"),
                route_name: "policiesManagement",
                icon: "bx bx-file-blank",
            },
            {
                title: t("countries"),
                route_name: "ListOfCountries",
                icon: "bx bx-world",
            },
            {
                title: t("cities"),
                route_name: "ListOfCities",
                icon: "bx bxs-city",
            },
        ],
    },
] as NavLink[];
